<template>
  <div>
    <svg
        v-if="icon === 'chevron-down'"
        xmlns="http://www.w3.org/2000/svg"
        :width="width"
        :height="height"
        fill="currentColor"
        class="bi bi-chevron-down"
        viewBox="0 0 16 16"
    >
      <path
          fill-rule="evenodd"
          d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
      />
    </svg>

    <svg
        v-if="icon === 'chevron-left'"
        xmlns="http://www.w3.org/2000/svg"
        :width="width"
        :height="height"
        fill="currentColor"
        class="bi bi-chevron-left"
        viewBox="0 0 16 16"
    >
      <path
          fill-rule="evenodd"
          d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
      />
    </svg>

    <svg
        v-if="icon === 'chevron-right'"
        xmlns="http://www.w3.org/2000/svg"
        :width="width"
        :height="height"
        fill="currentColor"
        class="bi bi-chevron-right"
        viewBox="0 0 16 16"
    >
      <path
          fill-rule="evenodd"
          d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
      />
    </svg>

    <svg
        v-if="icon === 'search'"
        xmlns="http://www.w3.org/2000/svg"
        :width="width"
        :height="height"
        fill="currentColor"
        class="bi bi-search"
        viewBox="0 0 16 16"
    >
      <path
          d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"
      />
    </svg>
    <svg
        class="animate-spin"
        v-if="icon == 'loading'"
        :height="height"
        :width="width"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
    >
      <circle
          class="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          stroke-width="4"
      ></circle>
      <path
          class="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>
    <svg
        v-if="icon === 'back'"
        xmlns="http://www.w3.org/2000/svg"
        :width="width"
        :height="height"
        fill="currentColor"
        class="bi bi-arrow-left"
        viewBox="0 0 16 16"
    >
      <path
          fill-rule="evenodd"
          d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"
      />
    </svg>
    <svg
        v-if="icon === 'hamburger'"
        xmlns="http://www.w3.org/2000/svg"
        :width="width"
        :height="height"
        fill="currentColor"
        class="bi bi-list"
        viewBox="0 0 16 16"
    >
      <path
          fill-rule="evenodd"
          d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"
      />
    </svg>
    <svg
        v-if="icon === 'lock'"
        xmlns="http://www.w3.org/2000/svg"
        :width="width"
        :height="height"
        fill="currentColor"
        class="bi bi-lock"
        viewBox="0 0 16 16"
    >
      <path
          fill-rule="evenodd"
          d="M8 0a4 4 0 0 1 4 4v2.05a2.5 2.5 0 0 1 2 2.45v5a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 13.5v-5a2.5 2.5 0 0 1 2-2.45V4a4 4 0 0 1 4-4M4.5 7A1.5 1.5 0 0 0 3 8.5v5A1.5 1.5 0 0 0 4.5 15h7a1.5 1.5 0 0 0 1.5-1.5v-5A1.5 1.5 0 0 0 11.5 7zM8 1a3 3 0 0 0-3 3v2h6V4a3 3 0 0 0-3-3"
      />
    </svg>
    <svg
        v-if="icon === 'plus'"
        xmlns="http://www.w3.org/2000/svg"
        :width="width"
        :height="height"
        fill="currentColor"
        class="bi bi-plus-lg"
        viewBox="0 0 16 16"
    >
      <path
          fill-rule="evenodd"
          d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"
      />
    </svg>
    <svg
        v-if="icon === 'minus'"
        xmlns="http://www.w3.org/2000/svg"
        :width="width"
        :height="height"
        fill="currentColor"
        class="bi bi-dash"
        viewBox="0 0 16 16"
    >
      <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8" />
    </svg>
    <svg
        v-if="icon === 'close'"
        xmlns="http://www.w3.org/2000/svg"
        :width="width"
        :height="height"
        fill="currentColor"
        class="bi bi-x"
        viewBox="0 0 16 16"
    >
      <path
          d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"
      />
    </svg>
    <svg
        v-if="icon === 'change'"
        xmlns="http://www.w3.org/2000/svg"
        :width="width"
        :height="height"
        viewBox="0 0 14 10"
    >
      <g fill="none" fill-rule="evenodd">
        <path fill="#E83838" d="M0 6l3 4 3-3.953zm2-6h2v6H2z" />
        <path fill="#207C2F" d="M8 3.954L11 0l3 4zM10 4h2v6h-2z" />
      </g>
    </svg>
    <svg
        v-if="icon === 'Corners'"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        :width="width"
        :height="height"
        viewBox="0 0 10 13"
    >
      <defs>
        <path
            id="a"
            d="M0 .1c2.2 1.298 5.2 2.3 9 3.006-3.884 2.37-6.884 3.372-9 3.007V.1z"
        />
      </defs>
      <g fill="none" fill-rule="evenodd">
        <g transform="translate(1 .5)">
          <path
              fill="#E83838"
              fill-rule="nonzero"
              d="M0 .1c2.2 1.298 5.2 2.3 9 3.006-3.884 2.37-6.884 3.372-9 3.007V.1z"
          />
          <mask id="b" fill="#fff"><use xlink:href="#a" /></mask>
          <path
              fill="#000"
              fill-rule="nonzero"
              d="M0 .1C.464.02 2.21.093 2.671.1c1.825 2.112-2.504 1.552-1.4 6.006-.337.95-.813.362-1.271.007V.1z"
              mask="url(#b)"
              opacity=".2"
          />
        </g>
        <path
            fill="#A7A7A7"
            fill-rule="nonzero"
            d="M0 .142a.953.953 0 0 1 1 0v12.734c-.267.152-.747.178-1 0V.142z"
        />
      </g>
    </svg>
    <svg
        v-if="icon === 'Score'"
        :height="height"
        :width="width"
        viewBox="0 0 11 11"
        xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fill-rule="evenodd">
        <path
            d="M0 5.68a5.156 5.156 0 1 1 10.312 0A5.156 5.156 0 0 1 0 5.68z"
            fill="#fff"
        />
        <g fill="#545454">
          <path
              d="M.86 8.84c.474-.045 2.393-.318 2.53-.428v-.327l-2.703.442.173.313zm2.871 1.948c.12-.462.294-1.049.237-1.216l-.306-.111-.225 1.257s.101.037.19.058c.042.01.08.016.104.012zM.102 6.793l1.309-3.334-.264-.186L0 6.421zM3.765 6.408L2.379 3.273l-.316.039 1.425 3.197zM1.328 2.666l-.463-.08-.177.238.492.095zM5.696 7.226l2.582-2.422-.245-.156L5.5 7.025zM7.26.675c-.152-.087-.225-.08-.385-.152l1.606 1.57h.43S7.71 1.159 7.259.675zM3.35.617s-.368.309-.6.705l.133.137.787-.936zM9.451 4.648l-.248.216-.265 3.725.285-.242zM8.87 9.464a5.59 5.59 0 0 0 .153-.168l-3.465-.523-.058.268s3.19.51 3.37.423zm-1.725-6.37s-.05-.163 0-.22L3.57 1.898l-.132.208z"
          />
        </g>
        <path
            d="M5.542 6.521s-.59-.093-1.243-.249c-.652-.156-.994-.249-.994-.249s-.404.467-.746.997c-.341.53-.496 1.246-.496 1.246l1.49 1.495 2.237-.996zm4.175 1.583l-.858-.018-1.328 1.187s-.056.924.054 1.012c.563-.198 1.754-1.173 2.132-2.181zM7.62 4.889l1.884.616s.364-.654.423-.917c.05-.226.17-.726.17-.726s-.241-.622-.749-1.252c-.094-.11-1.23-.712-1.23-.712l-1.243.997zm-5.372-.917l1.49-1.765-.496-.997-1.54.55-.417.377s-.373.507-.528.818c-.156.312 0 .997 0 .997h1.49zm-1.14 5.084L.723 7.593s-.16-.342-.378-.934c-.073-.2-.272-.412-.346-.636-.01.899.4 2.144 1.107 3.033z"
            fill="#111"
        />
      </g>
    </svg>
    <svg
        v-if="icon === 'RedCard'"
        :width="width"
        :height="height"
        viewBox="0 0 9 13"
        xmlns="http://www.w3.org/2000/svg"
    >
      <title>Rectangle 112</title>
      <rect
          x="143"
          y="565"
          width="9"
          height="13"
          rx="1"
          transform="translate(-143 -565)"
          fill="#E83838"
          fill-rule="evenodd"
      />
    </svg>
    <svg
        v-if="icon === 'YellowCard'"
        :width="width"
        :height="height"
        viewBox="0 0 9 13"
        xmlns="http://www.w3.org/2000/svg"
    >
      <title>Rectangle 112</title>
      <rect
          x="143"
          y="565"
          width="9"
          height="13"
          rx="1"
          transform="translate(-143 -565)"
          fill="#E4D539"
          fill-rule="evenodd"
      />
    </svg>
    <svg
        v-if="icon === 'copy'"
        xmlns="http://www.w3.org/2000/svg"
        :width="width"
        :height="height"
        fill="currentColor"
        class="bi bi-copy"
        viewBox="0 0 16 16"
    >
      <path
          fill-rule="evenodd"
          d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"
      />
    </svg>
    <svg
        v-if="icon === 'check'"
        xmlns="http://www.w3.org/2000/svg"
        :width="width"
        :height="height"
        fill="currentColor"
        class="bi bi-check2"
        viewBox="0 0 16 16"
    >
      <path
          d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0"
      />
    </svg>
    <svg
        v-if="icon === 'delete'"
        xmlns="http://www.w3.org/2000/svg"
        :width="width"
        :height="height"
        fill="currentColor"
        class="bi bi-trash3"
        viewBox="0 0 16 16"
    >
      <path
          d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5"
      />
    </svg>
    <svg
        v-if="icon === 'alert'"
        xmlns="http://www.w3.org/2000/svg"
        :width="width"
        :height="height"
        fill="currentColor"
        class="bi bi-exclamation-octagon"
        viewBox="0 0 16 16"
    >
      <path
          d="M4.54.146A.5.5 0 0 1 4.893 0h6.214a.5.5 0 0 1 .353.146l4.394 4.394a.5.5 0 0 1 .146.353v6.214a.5.5 0 0 1-.146.353l-4.394 4.394a.5.5 0 0 1-.353.146H4.893a.5.5 0 0 1-.353-.146L.146 11.46A.5.5 0 0 1 0 11.107V4.893a.5.5 0 0 1 .146-.353zM5.1 1 1 5.1v5.8L5.1 15h5.8l4.1-4.1V5.1L10.9 1z"
      />
      <path
          d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z"
      />
    </svg>
    <svg
        v-if="icon === 'review'"
        xmlns="http://www.w3.org/2000/svg"
        :width="width"
        :height="height"
        fill="currentColor"
        class="bi bi-arrow-repeat"
        viewBox="0 0 16 16"
    >
      <path
          d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41m-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9"
      />
      <path
          fill-rule="evenodd"
          d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5 5 0 0 0 8 3M3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9z"
      />
    </svg>
    <svg
        v-if="icon === 'print'"
        xmlns="http://www.w3.org/2000/svg"
        :width="width"
        :height="height"
        fill="currentColor"
        class="bi bi-printer"
        viewBox="0 0 16 16"
    >
      <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1" />
      <path
          d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1"
      />
    </svg>
    <svg
        v-if="icon === 'calendar'"
        xmlns="http://www.w3.org/2000/svg"
        :width="width"
        :height="height"
        fill="currentColor"
        class="bi bi-calendar"
        viewBox="0 0 16 16"
    >
      <path
          d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z"
      />
    </svg>
    <svg
        v-if="icon === 'settings'"
        xmlns="http://www.w3.org/2000/svg"
        :width="width"
        :height="height"
        fill="currentColor"
        class="bi bi-gear"
        viewBox="0 0 16 16"
    >
      <path
          d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492M5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0"
      />
      <path
          d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.292-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.292c.415.764-.42 1.6-1.185 1.184l-.292-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.292A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115z"
      />
    </svg>
  </div>
</template>

<script lang="ts">
export default {
  name: 'IllinoisIcons',
  props: {
    icon: {
      type: String,
      required: true
    },
    width: {
      type: Number,
      required: false,
      default: 16
    },
    height: {
      type: Number,
      required: false,
      default: 16
    }
  }
};
</script>

<style scoped>
svg {
  overflow: visible;
}
</style>
